import { ArrowRight } from "lucide-react";
import { LogoMark } from "./Logo";
import { Reveal } from "./Motion";
import { signupUrl } from "@/data/networks";

export const CtaBand = ({ source = "hearthside", follow }) => (
  <section className="max-w-7xl mx-auto px-5 sm:px-8 pb-24" data-testid="cta-band">
    <Reveal>
      <div className="relative overflow-hidden rounded-[2rem] bg-[#181412] text-[#FBF8F4] p-8 sm:p-14 lg:p-20">
        <LogoMark className="absolute -right-10 -bottom-16 h-[340px] w-[340px] text-[#FBF8F4]/[0.04]" />
        <div className="relative max-w-2xl">
          <div className="font-mono text-xs uppercase tracking-[0.25em] text-[#D4A373]">For the family</div>
          <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight">
            Every paper your family will need — <em className="text-[#D4A373]">filed, dated and ready.</em>
          </h2>
          <p className="mt-5 text-[#C8BFB8] leading-relaxed">
            Takes two minutes: your family's name, your name, a PIN — done. No card needed, and your first 14 days include everything in Plus.
          </p>
          <div className="mt-9 flex flex-wrap gap-3">
            <a
              href={signupUrl(source)}
              data-testid="cta-band-signup-btn"
              className="group inline-flex items-center gap-2 rounded-full bg-[#B4532A] hover:bg-[#9C421E] h-12 px-6 text-sm font-medium transition-colors duration-300"
            >
              <LogoMark className="h-4 w-4" /> Create your vault — free
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
            </a>
            {follow}
          </div>
        </div>
      </div>
    </Reveal>
  </section>
);
